import axios from 'axios'

const serverEnv = import.meta.env.VITE_SERVER_ENV

const backendHost = {
  'production': 'https://datagateway.fractaltecnologia.com.br',
  'staging': 'https://staging.datagateway.fractaltecnologia.com.br',
  'homolog': 'https://homolog.datagateway.fractaltecnologia.com.br',
  'development': 'https://dev-datagateway.fractaltecnologia.com.br',
  'demo': 'https://demo-datagateway.fractaltecnologia.com.br',
  'local': 'http://localhost:3000'
}

const setAPIEnv = () =>
  serverEnv ? backendHost[serverEnv] : backendHost['development']

const apiVersion = 'v1'

const instance = axios.create({
  baseURL: `${setAPIEnv()}/api/${apiVersion}`
})

export const host = backendHost

export default instance
